import { useEffect, useState } from 'react';
import { InputNumber, InputSize } from '@ui/src';
import { CustomerStatus } from '@clients/hoc/customers/types';
import { AnnualIncomeTypes } from './types';
import RegulatedCompanyRow from './row';

const AnnualIncome = ({
  id,
  name,
  clearErrors,
  status,
  annualIncomesValues,
  setValue,
  annualIncomesValue,
}: AnnualIncomeTypes) => {
  const [formValues, setFormValues] = useState<{
    sourceOfAnnualIncomeId: string;
    percentage?: string | number;
  }>({
    sourceOfAnnualIncomeId: '',
  });

  useEffect(() => {
    if (annualIncomesValue) {
      setFormValues(annualIncomesValue);
    } else {
      setFormValues({
        sourceOfAnnualIncomeId: id,
        percentage: '',
      });
    }
  }, [annualIncomesValue, id]);

  return (
    <RegulatedCompanyRow title={name} annualIncome>
      <InputNumber
        name={id}
        placeholder="Enter percent..."
        value={formValues?.percentage}
        size={InputSize.SMALL}
        onChange={(e) => {
          clearErrors(['sourcesOfAnnualIncomes']);

          const nextFormValues = { ...formValues };

          let nextAnnualIncomeValues: {
            sourceOfAnnualIncomeId: string;
            percentage?: string | number;
          }[] = [];

          if (annualIncomesValues) {
            nextAnnualIncomeValues = (
              [] as {
                sourceOfAnnualIncomeId: string;
                percentage?: string | number;
              }[]
            ).concat(annualIncomesValues);
          }

          if (Number(e.target.value) < 0) {
            nextFormValues.percentage = 0;
          } else if (Number(e.target.value) >= 100) {
            nextAnnualIncomeValues = nextAnnualIncomeValues?.map((item) => {
              const result = { ...item };

              if (
                result.sourceOfAnnualIncomeId !==
                formValues.sourceOfAnnualIncomeId
              ) {
                result.percentage = '';
              }

              return result;
            });

            nextFormValues.percentage = 100;
          } else {
            nextFormValues.percentage = Number(e.target.value);
          }

          if (
            !nextAnnualIncomeValues.find(
              (item) =>
                item.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId,
            )
          ) {
            nextAnnualIncomeValues.push(nextFormValues);
          } else if (
            nextAnnualIncomeValues.find(
              (item) =>
                item.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId,
            )
          ) {
            nextAnnualIncomeValues = nextAnnualIncomeValues?.map((item) => {
              const result = { ...item };

              if (
                result.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId
              ) {
                result.percentage = Number(e.target.value);
              }

              return result;
            });
          }

          setFormValues(nextFormValues);

          setValue(
            'sourcesOfAnnualIncomes',
            nextAnnualIncomeValues as {
              sourceOfAnnualIncomeId: string;
              percentage?: string | number;
            }[],
          );
        }}
        className="borderless"
        disabled={status === CustomerStatus.CLOSED}
        tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
      />
    </RegulatedCompanyRow>
  );
};

export default AnnualIncome;
